<button
  #menuOrigin="cdkOverlayOrigin"
  cdkOverlayOrigin
  type="button"
  class="btn user-account-menu__trigger"
  [class.user-account-menu__trigger--with-logo]="logoFileUrl"
  [attr.aria-controls]="menuId"
  [attr.aria-expanded]="showMenu"
  (click)="onBtnClick()"
>
  @if (!logoFileUrl) {
    <div class="d-flex align-items-center justify-content-center h-100">
      <i class="user-account-menu__avatar-placeholder"></i>
    </div>
  }
  @if (logoFileUrl) {
    <img class="user-account-menu__avatar-image" [src]="logoFileUrl" (error)="logoFileUrl = ''" />
  }
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="menuOrigin"
  [cdkConnectedOverlayOpen]="showMenu"
  [cdkConnectedOverlayPositions]="menuOverlayPositions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (detach)="close()"
  (overlayOutsideClick)="close()"
>
  <div class="user-account-menu__panel" [attr.id]="menuId" (pointerenter)="onPointerEnter()" (pointerleave)="onPointerLeave($event)">
      <div class="user-account-menu__profile">
        <div class="d-flex align-items-center">
          <div class="user-account-menu__photo">
            <label class="user-account-menu__photo-action" (click)="onLogoClick()">
              <input class="d-none" type="file" (change)="onChangeIcon($event.target.files)" />
              {{ 'CHOOSE_IMAGE_BTN' | translate }}
            </label>
            <div class="user-account-menu__avatar">
              @if (!logoFileUrl) {
                <i class="user-account-menu__avatar-placeholder"></i>
              }
              @if (logoFileUrl) {
                <img class="user-account-menu__avatar-image" [src]="logoFileUrl" />
              }
            </div>
          </div>
          <div>
            <div class="user-account-menu__name">{{ name }}</div>
            <div class="user-account-menu__email">{{ email }}</div>
          </div>
        </div>
      </div>
      <ul>
        <li class="d-lg-none">
          <app-language-select [type]="languageSelectorType"></app-language-select>
        </li>
        <li>
          <a class="user-account-menu__item" routerLink="/dh/change-password" (click)="close()">
            <img src="assets/icons/toolbar/lock.png" class="user-account-menu__item-icon user-account-menu__lock-icon" />
            {{ 'CHANGE_PASSWORD_BTN' | translate }}
          </a>
        </li>
        <li>
          <a class="user-account-menu__item" routerLink="/dh/notification-setting" (click)="close()">
            <img src="assets/icons/toolbar/notification-email.png" class="user-account-menu__item-icon" />
            {{ 'NOTIFICATION_SETTING.CONFIG_BTN' | translate }}
          </a>
        </li>
        @if (isAdmin) {
          <li>
            <a class="user-account-menu__item" (click)="onOpenLicenseSidebar()">
              @if (hasBreachedLimits) {
                <i
                  class="fa-solid fa-triangle-exclamation user-account-menu__limit-warning"
                  [attr.title]="'LICENSE_LIMIT.LIMITS_BREACHED_ICON' | translate"
                  aria-hidden="true"
                  ><span class="screen-reader-only">{{ 'LICENSE_LIMIT.LIMITS_BREACHED_ICON' | translate }}</span></i
                  >
                  }<i
                    class="fa-thin fa-file-certificate user-account-menu__license-icon user-account-menu__item-icon"
                    [attr.title]="'LICENSE_LIMIT.LICENSES_ICON' | translate"
                  ><span class="screen-reader-only">{{ 'LICENSE_LIMIT.LICENSES_ICON' | translate }}</span></i
                  >
                  {{ 'LICENSE_LIMIT.LICENSE' | translate }}
                </a>
              </li>
            }
            <li>
              <a class="user-account-menu__item" (click)="logout()">
                <img src="assets/icons/toolbar/logout.png" class="user-account-menu__item-icon" />
                {{ 'LOGOUT_BTN' | translate }}
              </a>
            </li>
      </ul>
  </div>
</ng-template>

    <ng-template #licenseSidebar>
      <div class="license-sidebar-content">
        <h2>{{ 'LICENSE_LIMIT.LICENSE' | translate }}</h2>
        <p>
          {{ 'LICENSE_LIMIT.DESCRIPTION' | translate }}
        </p>
        @if (hasBreachedLimits && limitsComparison) {
          <app-information-block
            [mode]="'bubble'"
            [status]="'error'"
            [text]="'LICENSE_LIMIT.ONE_OR_MULTIPLE_LIMITS_BREACHED' | translate"
          ></app-information-block>
        }
        @if (limitsComparison) {
          <div>
            <ul class="limits-comparison-list">
              <li class="limits-comparison-list__item" [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.dwelling }">
                <span class="limits-comparison-list__level">{{ limitsComparison.dwellingLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.dwelling }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.dwellingLimit ?? 0 }
                }}</span>
                {{ limitsComparison.dwellingLimit === 1 ? ('LICENSE_LIMIT.DWELLING' | translate) : ('LICENSE_LIMIT.DWELLINGS' | translate) }}
              </li>
              <li class="limits-comparison-list__item" [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.parking }">
                <span class="limits-comparison-list__level">{{ limitsComparison.parkingLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.parking }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.parkingLimit ?? 0 }
                }}</span>
                {{
                limitsComparison.parkingLimit === 1 ? ('LICENSE_LIMIT.PARKING_SPACE' | translate) : ('LICENSE_LIMIT.PARKING_SPACES' | translate)
                }}
              </li>
              <li
                class="limits-comparison-list__item"
                [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.otherObject }"
                >
                <span class="limits-comparison-list__level">{{ limitsComparison.otherObjectLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.otherObject }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.otherObjectLimit ?? 0 }
                }}</span>
                {{
                limitsComparison.otherObjectLimit === 1
                ? ('LICENSE_LIMIT.OTHER_OBJECT' | translate)
                : ('LICENSE_LIMIT.OTHER_OBJECTS' | translate)
                }}
              </li>
              <li
                class="limits-comparison-list__item"
                [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.premisesSqm }"
                >
                <span class="limits-comparison-list__level">{{ limitsComparison.premisesSqmLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.premisesSqm }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.premisesSqmLimit ?? 0 }
                }}</span>
                {{ 'LICENSE_LIMIT.PREMISES_SQM' | translate }}
              </li>
            </ul>
          </div>
        }

        <app-information-block [mode]="'bubble'" [status]="'info'" [text]="'LICENSE_LIMIT.ROUND_UP_INFO' | translate"></app-information-block>
      </div>
    </ng-template>
